import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProductoService } from '@abm/producto/producto.service';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { TipoProducto } from '@shared/enums/tipoProducto';
import { Producto } from '@shared/models/abm/Producto';
import { ReporteMovimientoBalance7 } from '@shared/models/cierreTurno/ReporteMovimientoBalance7';
import { MessageService } from '@shell/message.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

enum TipoFiltro {
  a15Grados = 0,
  natural = 1
}
@Component({
  selector: 'app-stock-actual',
  templateUrl: './stock-actual.component.html',
  styleUrls: ['./stock-actual.component.scss']
})
export class StockActualComponent implements OnInit, OnDestroy {

  TipoProducto = TipoProducto;
  TipoFiltro = TipoFiltro;

  cancelAsyncsRequests = false;
  soloPAD = true;
  checkEnabled = true;
  listaProductos: Producto[] = [];
  stockAeroplantas = [];
  stockAeroplantasFiltradas = [];

  tipoFiltroSeleccionado = TipoFiltro.natural;
  obteniendoStockContenedores: boolean = false;
  obteniendoFiltro: boolean = false;

  /**
   * cuando el usuario destilda/tilda soloPAD, resetea la consulta asincrona de todas las aeroplantas, 
   * si quedo un hilo ejecutandose lo cancela y arranca de nuevo
   */ 
  indexContador:number=1;
  requestCanceladas:number[]=[]; 
  aeroplantas

  private ngUnsubscribe = new Subject();

  constructor(private cierreTurnoService: CierreTurnoService,
    private productoService: ProductoService,
    private comprobanteService: ComprobanteService,
    private messageService: MessageService) { }

  ngOnInit() {    
    this.obteniendoFiltro = true;
    this.initProducts();
  }

  initProducts() {
    this.productoService.obtenerProductos()
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(r=>{
      this.listaProductos = r.filter(p => p.tipoProducto != TipoProducto.Servicios).sort((a,b) => this.productoComparator(a, b));
      this.procesarAerolantas();
    });
  }

  initArray() {
    this.stockAeroplantas=[];
    this.stockAeroplantasFiltradas=[];
    this.cancelAsyncsRequests=false;
    this.requestCanceladas=[];
    this.indexContador = 1;
    this.checkEnabled=true;
  }

  cancel() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  changeSoloPAD() {    
    this.checkEnabled=false;
    setTimeout(() => {
      this.checkEnabled=true;
    }, 15000);      
    
    if(this.obteniendoStockContenedores) {
      this.cancelAsyncsRequests = true;      
      this.requestCanceladas.push(this.indexContador-1);
    } else {
      this.initArray();
    }   
    this.procesarAerolantas();
  }

  procesarAerolantas() {    
    this.obteniendoStockContenedores = true;
    this.comprobanteService.getDatosAeroplanta(null)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(aeroplantas => {
        aeroplantas= aeroplantas.filter( a => a.codigoAeroplanta != "SCL" && a.codigoAeroplanta != "SCE")
        aeroplantas= this.soloPAD ? aeroplantas.filter( a => a.soloPAD ) : aeroplantas
        aeroplantas = aeroplantas.sort( (a, b) => a.nombre < b.nombre ? -1 : 1 )
        console.log(aeroplantas.length);
        this.obteniendoFiltro = false;
        this.procesarStockAeroplantas(aeroplantas, this.indexContador++);
      });
  }

  async procesarStockAeroplantas(aeroplantas, index) {
    this.obteniendoStockContenedores = true;
    const indexInterno=index;
    console.log("procesando request "+indexInterno);
    for (const aeroplanta of aeroplantas) {
      if(this.soloPAD) {
        if(aeroplanta.soloPAD==false) {
          continue
        }
      }
      // Al destruir el componente este metodo asincrono sigue corriendo hasta finalizar, por eso la 
      // condición de corte que se activa en el ngOnDestroy
      if(this.requestCanceladas.includes(indexInterno) && this.cancelAsyncsRequests) {        
        this.initArray();
        console.log("cancelando request "+indexInterno);
        break; 
      }      

      try {
        let stockDataAeroplanta: ReporteMovimientoBalance7[] = [];
        const fecha = new Date();
        const fechaDesde = this.formatDate(fecha.getFullYear(), fecha.getMonth() + 1, fecha.getDate(), fecha.getHours(), fecha.getMinutes());
        stockDataAeroplanta = await this.cierreTurnoService.getMovimientosBalance7PorFechaPromise(null, aeroplanta.codigoAeroplanta, fechaDesde, fechaDesde, true);
        const aeroplantaData = { aeroplanta: this.armarRotuloAeroplanta(aeroplanta), stock: stockDataAeroplanta };
        this.stockAeroplantas.push(aeroplantaData);
        this.stockAeroplantasFiltradas.push(this.filtrarAeroplantaDataPorTipo(aeroplantaData, this.tipoFiltroSeleccionado));

      } catch (Ex) {
        this.messageService.showErrorMessage("Error de backend: "+Ex.description);
        this.initArray();
        this.procesarStockAeroplantas(aeroplantas, this.indexContador);
        return;
      }
    }

    this.obteniendoStockContenedores = false;
  }

  formatDate(year, month, day, hour, minute): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00';
  }

  armarRotuloAeroplanta(aeroplanta) {
    return aeroplanta.codigoAeroplanta + " - " + aeroplanta.nombre;
  }

  filtrarNatural() {
    this.tipoFiltroSeleccionado = TipoFiltro.natural;
    this.filtrar();
  }

  filtrar15() {
    this.tipoFiltroSeleccionado = TipoFiltro.a15Grados;
    this.filtrar();
  }

  filtrar() {
    this.stockAeroplantasFiltradas = this.stockAeroplantas.map( aeroplantaData => {
      return this.filtrarAeroplantaDataPorTipo(aeroplantaData, this.tipoFiltroSeleccionado);
    });
  }

  filtrarAeroplantaDataPorTipo(aeroplantaData, tipo){
    const aux = {...aeroplantaData};
    aux.stock = aeroplantaData.stock.filter( s => s.tipoReporte == tipo );
    return aux;
  }

  renderizarStockPorProducto(codigoProducto, stock: ReporteMovimientoBalance7[]){
    return stock.find(s => s.codigoProducto == codigoProducto)?.final || "x";
  }

  productoComparator(a, b){
    // Primero Aerocombustible, luego Combustible y finalmente Aeroespecialidad
    if(a.tipoProducto == TipoProducto.Aerocombustible && b.tipoProducto != TipoProducto.Aerocombustible){
      return -1;
    }else if(a.tipoProducto == TipoProducto.Aerocombustible && b.tipoProducto == TipoProducto.Aerocombustible){
      return a.codigo < b.codigo ? -1 : 1;
    }else if(a.tipoProducto == TipoProducto.Combustible && b.tipoProducto == TipoProducto.Aerocombustible){
      return 1;
    }else if(a.tipoProducto == TipoProducto.Combustible && b.tipoProducto != TipoProducto.Combustible){
      return -1;
    }else if(a.tipoProducto == TipoProducto.Combustible && b.tipoProducto == TipoProducto.Combustible){
      return a.codigo < b.codigo ? -1 : 1;
    } else if(a.tipoProducto == TipoProducto.Aeroespecialidad && b.tipoProducto != TipoProducto.Aeroespecialidad){
      return 1;
    }else if(a.tipoProducto == TipoProducto.Aeroespecialidad && b.tipoProducto == TipoProducto.Aeroespecialidad){
      return a.codigo < b.codigo ? -1 : 1;
    }else{
      return -1;
    }
  }

  ngOnDestroy(): void {
    this.requestCanceladas.push(this.indexContador-1);
    this.cancelAsyncsRequests = true;
    this.cancel();    
  }
}
